export default {
	methods: {
		scrollToTop(topDivId) {
			let scrollElm = document.querySelector(topDivId);
			scrollElm.scrollTop = 0;
		},
	},
};
